import { useState } from 'react'
import { useMutation } from '@apollo/client'
import { UPDATE_AD_ASSET_THUMBNAIL } from '@/graphql/ads/ad-assets-queries'
import { COPY_CUSTOM_THUMBNAIL_TO_ASSET } from '@/graphql/custom-thumbnail-upload-queries'

export const useThumbnailEditor = (refetchAssets) => {
    const [showThumbnailEditor, setShowThumbnailEditor] = useState(false)
    const [selectedAsset, setSelectedAsset] = useState(null)
    const [isUpdatingThumbnail, setIsUpdatingThumbnail] = useState(false)
    const [currentSelection, setCurrentSelection] = useState({ mode: 'automatic' })
    const [uploadState, setUploadState] = useState('idle')

    const [updateAdAssetVideoThumbnail] = useMutation(UPDATE_AD_ASSET_THUMBNAIL)
    const [copyCustomThumbnailToAsset] = useMutation(COPY_CUSTOM_THUMBNAIL_TO_ASSET)

    const openThumbnailEditor = (asset) => {
        setSelectedAsset(asset)
        setShowThumbnailEditor(true)
        setCurrentSelection({ mode: 'automatic' }) // Clear any current selection
        setUploadState('idle') // Reset upload state
    }

    const closeThumbnailEditor = () => {
        setShowThumbnailEditor(false)
        setSelectedAsset(null)
    }

    // Handle selection changes from the VideoThumbnailEditor component
    const handleSelectionChange = (selectionData) => {
        setCurrentSelection(selectionData)
        if (selectionData.uploadState !== undefined) {
            setUploadState(selectionData.uploadState)
        }
    }

    // Handle saving the selected thumbnail to the database
    const handleSaveThumbnail = async () => {
        setIsUpdatingThumbnail(true)
        setShowThumbnailEditor(false)

        try {
            if (currentSelection.mode === 'upload') {
                await copyCustomThumbnailToAsset({ variables: { adCreativeAssetId: selectedAsset.id } })
            } else {
                let frameId

                if (currentSelection.mode === 'automatic') frameId = currentSelection.firstThumbnail?.id
                else frameId = currentSelection.selectedThumbnail?.id

                if (!frameId) throw new Error('No thumbnail available to save')

                await updateAdAssetVideoThumbnail({ variables: { assetId: selectedAsset.id, frameId } })
            }

            await refetchAssets()
        } finally {
            setIsUpdatingThumbnail(false)
        }
    }

    return {
        showThumbnailEditor,
        selectedAsset,
        isUpdatingThumbnail,
        currentSelection,
        uploadState,
        openThumbnailEditor,
        closeThumbnailEditor,
        handleSelectionChange,
        handleSaveThumbnail,
    }
}
